export default class PoLineException {
    poId:number;
    poLineNumber:number;
    qty:number;
    note:string;
    type:string;
    creationTime:Date;
    typeName:string;
    creatorUserName:string;
    operator: string;
}